import React, { useState, useMemo, useEffect, useContext } from 'react'
import { Form, Row, Col, Button, Accordion, Modal } from 'react-bootstrap'
import { AiFillEdit } from 'react-icons/ai'
import { Formik } from 'formik'
import * as yup from 'yup'

import api from '../../services/api';
import TableCard from '../tableCard/index.js'
import AlertCustom from '../alertCustom/index.js'
import BtnLoader from '../buttons/loader/index.js'
import errorHandler from '../errorHandler/index.js'
import NavigationBar from '../navigationBar/index.js'
import ManualFileForm from '../manualFileForm/index.js'
import StoreContext from '../../components/storage/context'
import errorHandlerShow from '../errorHandlerShow/index.js'
import ControlWithValidation from '../fields/controlWithValidation/index.js'
import SelectWithValidation from '../fields/selectWithValidation/index.js'
import ControlAreaWithValidation from '../fields/controlAreaWithValidation/index.js'

import './styles.css'

// define a página de aprovação dos arquivos manuais 
const ManualFileApproval = () => {
	// restaga o token obtido no contexto StoreContext
	const { pk_user, givenName, pk_service, token, setToken } = useContext(StoreContext);

	const [rowSelect, setRowSelect] = useState()
	const [lgShow, setLgShow] = useState(false);
	const [metadata, setMetadata] = useState([]);
	const [packed, setPacked] = useState("yes");
	const [loading, setLoading] = useState(false);
	const [readOnly, setReadOnly] = useState(true);

	// variables used for save manual file
	const [fields, setFields] = useState([])
	const [data, setData] = useState({
		is_project: '',
		justification_ingestion: '',
		project_name: '',
		requesting_area: '',
		requesting_company: '',
		requesting_email: '',
		requesting_name: '',

		area_for_business_data: '',
		company: '',
		domain_data: '',
		public_data: '',
		subject_data: '',
		responsible_for_business_data: '',

		maximum_data_history_time: '',
		maximum_data_history_time_unit: '',
		delimiter: '',
		desc_entity: '',
		entity_name: '',
		extension_file: '',
		frequency: '',
		type_load: '',
		encoding: '',
		pattern_file: "{entity_name}_{pattern_date}",

		// campo com valores fixos
		source_type: 'arquivos manuais',
		source_name: 'arquivos manuais',
		pk_user: pk_user,
		given_name: givenName,

		// fields to save in dynamo entity
		system_name: 'arquivos_manuais',
		account_destination: 'coe',
		datalake_destination: 'trusted',
		chunk_size: "256000000",
		pattern_date: '%Y%m%d',
		source_path: '{entity_name}',
		active: true,
		header: true,
		version: 0,
		name_responsible_validation: '',
		email_responsible_validation: '',
		validation_date: '',
		validation_status: '',
		desc_validation: '',

		// campos que não serão usados p/ arquivos manuais
		responsible_for_technical_data: '',
		area_for_technical_data: '',
		target_location: '',
		source_external: '',
		business_rules: '',
		related_entity: '',
		data_filter_source: '',
		primary_key_reuse: '',
		record_deletion_allowed: '',
		pattern_data: ''
	})

	const [dataValidation, setDataValidation] = useState({
		name_responsible_validation: '',
		email_responsible_validation: '',
		validation_status: '',
		desc_validation: '',
		new_version: false,
		pk_control: 1
	})

	// show alert to users
	const [showAlert, setShowAlert] = useState(false);
	const [alert, setAlert] = useState({ header: '', message: '', type: '', options_btn: [] });

	const [search, setSearch] = useState({ 'metadata': {}, 'entity': { 'fields': [] }, 'control': {}, 'message': '' })

	const columnsFields = ['#', 'Nome do campo', 'Tipo do dado', 'Descrição', 'Descrição dos códigos', 'Mascara dos campos', 'LGPD', 'Exemplo', 'Status']
	const rowsFields = [
		{
			'id': '001',
			'name': 'nome do campo',
			'type': 'String',
			'description': 'Descrição',
			'descriptionCode': 'Descrição dos códigos',
			'mask': 'Mascara dos campos',
			'LGPD': 'Sim',
			'example': 'Exemplo',
			'status': false,
			'actions': 'Ações'
		},
		{
			'id': '002',
			'name': 'nome do campo',
			'type': 'String',
			'description': 'Descrição',
			'descriptionCode': 'Descrição dos códigos',
			'mask': 'Mascara dos campos',
			'LGPD': 'Sim',
			'example': 'Exemplo',
			'status': true,
			'actions': 'Ações'
		},
		{
			'id': '003',
			'name': 'nome do campo',
			'type': 'String',
			'description': 'Descrição',
			'descriptionCode': 'Descrição dos códigos',
			'mask': 'Mascara dos campos',
			'LGPD': 'Sim',
			'example': 'Exemplo',
			'status': true,
			'actions': 'Ações',
		}
	]

	const navegation = [
		{
			'nome': 'home',
			'link': '/'
		},
		{
			'nome': 'cadastro arquivos manuais',
			'link': `/cadastro-arq-manual?service_id=${pk_service}`
		},
		{
			'nome': 'homologar',
			'link': '/cadastro-arq-manual/homologar'
		}
	]

	useEffect(() => {
		api.get('manual-file/metadata', {
			params: { 'pk_user': pk_user },
			headers: { 'Authorization': token }
		})
		.then(response => {
			setMetadata(response.data.control_metadata)
		})
		.catch(error => {
			errorHandlerShow(error, setToken, setAlert, setShowAlert)
		})
	}, []);

	let data_control = useMemo(() => metadata.map((item, index) => (
		{
			id: item.metadata.pk_metadata,
			version: item.control.version,
			fileName: item.metadata.entity_name,
			obs: item.control.desc_validation,
			status: item.control.validation_status
		}
	)))

	// exibe a linha selecionada na tabela
	const handleClickGroup = (values) => {

		setLgShow(true)
		api.get('manual-file/metadata', {
			params: { "pk_metadata": values.id, 'pk_user': pk_user },
			headers: { 'Authorization': token }
		})
		.then(response => {
			// setSearch(response.data)
			const res = response.data;

			setData({ ...data, ...res.metadata, ...res.control })

			if (res.entity) {
				setFields(res.entity.fields)
			} else {
				setAlert({
					header: 'Algo deu errado com sua solicitação.',
					message: "Não foi possível recuperar algumas informações do arquivo. \n Por gentileza, tente novamente mais tarde, caso o erro persista entre em contato com administrador do portal.",
					type: 'danger',
					options_btn: []
				})
				// show alert with mensage
				setLgShow(false)
				setShowAlert(true)
				setFields([])
			}
		})
		.catch(error => {
			errorHandlerShow(error, setToken, setAlert, setShowAlert)
			setFields([])
		})
	}

	const columns = useMemo(
		() => [
			{
				Header: '#',
				accessor: 'id', // accessor is the "key" in the data
			},
			{
				Header: 'Versão',
				accessor: 'version',
			},
			{
				Header: 'Nome do arquivo',
				accessor: 'fileName',
			},
			{
				Header: 'Observações da validação',
				accessor: 'obs',
			},
			{
				Header: 'Status da validação',
				accessor: 'status'
			},
			{
				width: 100,
				Header: "Ações",
				Cell: ({ value, column, row }) => (
					<div className='mf-approval-actions'>
						<AiFillEdit size={20} onClick={() => handleClickGroup(row.original)} />
					</div>
				)
			}
		],
		[]
	)

	const onSubmitSaveApproval = (forms) => {
		setLoading(true);

		api.post('manual-file/approval', { ...data, ...forms }, {
			params: { 'pk_user': pk_user },
			headers: { 'Authorization': token }
		})
		.then(response => {
			setAlert({
				header: 'Homologação do arquivo manual',
				message: response.data.message,
				type: 'success',
				options_btn: []
			})

			// show alert with mensage
			setShowAlert(true)
			setLoading(false)
			setLgShow(false)
		})
		.catch(error => {
			errorHandlerShow(error, setToken, setAlert, setShowAlert)
			setLoading(false)
		})
	}

	// schema de validação do formulario de requisição
	const approvalSchema = yup.object().shape({
		name_responsible_validation: yup.string().required(),
		email_responsible_validation: yup.string().required(),
		validation_status: yup.string().required(),
		desc_validation: yup.string().required(),
		new_version: yup.boolean(),
	});

	return (
		<div className="mf-approval-container">

			{/* Barra de navegação */}
			<NavigationBar navegation={navegation} />

			<AlertCustom showAlert={showAlert} setShowAlert={setShowAlert} alert={alert} />

			{/* Tabela com os arquivos pendentes */}
			<h1 className="mf-approval-title-table">Pendentes de homologação</h1>

			<TableCard data={data_control} columns={columns} setRowSelect={setRowSelect} />

			{/* formulario com dados do solicitante e governança */}
			<Modal
				dialogClassName="mfa-main-modal"
				// fullscreen={true}
				show={lgShow}
				onHide={() => setLgShow(false)}
				aria-labelledby="example-modal-sizes-title-lg"
			>
				<Modal.Header closeButton>
					<Modal.Title id="example-modal-sizes-title-lg">
						Aprovação da ingestão do arquivo manual
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>

					{/* FORMS */}
					<ManualFileForm
						showAlert={showAlert}
						setShowAlert={setShowAlert}
						setAlert={setAlert}
						action={"EditAndShow"}
						readOnly={readOnly}
						fields={fields}
						setFields={setFields}
						data={data}
						setData={setData} />

					<hr className="mf-approval-hr" />

					<h1 className="mf-approval-title-table">Considerações sobre ingestão do arquivo manual</h1>
					<ManualFileApprovalForms data={data} loading={loading} packed={packed} setPacked={setPacked} approvalSchema={approvalSchema} onSubmitSaveApproval={onSubmitSaveApproval} />

				</Modal.Body>
			</Modal>

		</div>
	);
}


// define formulário para aprovação dos arquivos manuais
const ManualFileApprovalForms = ({ data, loading, approvalSchema, onSubmitSaveApproval }) => (
	<Formik
		initialValues={{
			name_responsible_validation: data.name_responsible_validation,
			email_responsible_validation: data.email_responsible_validation,
			validation_status: data.validation_status,
			desc_validation: data.desc_validation,
			new_version: false
		}}
		validationSchema={approvalSchema}
		onSubmit={(values) => onSubmitSaveApproval(values)}
		validateOnChange={true}
		validateOnBlur={true}
		enableReinitialize
	>
		{({
			handleSubmit,
			handleChange,
			handleBlur,
			values,
			touched,
			isValid,
			errors,
			setFieldValue,
		}) => {
		
		let statusValidation = ["", "Aprovação Parcial", "Pendente", "Iniciado", "Reprovado", "Aprovação Final"]

		return (
			<Form className="mf-approval-form" noValidate onSubmit={handleSubmit}>
				<Row className="mb-3">

					<ControlWithValidation
						key="name_responsible_validation"
						Col={Col}
						type="text"
						label="Nome do responsável pela validação"
						name="name_responsible_validation"
						placeholder=""
						value={values.name_responsible_validation}
						error={errors.name_responsible_validation}
						handleChange={handleChange}
						typeColumn="xs"
						valueColumn={5}
					/>

					<ControlWithValidation
						key="email_responsible_validation"
						Col={Col}
						type="text"
						label="E-mail do responsável pela validação"
						name="email_responsible_validation"
						placeholder=""
						value={values.email_responsible_validation}
						error={errors.email_responsible_validation}
						handleChange={handleChange}
						typeColumn="xs"
						valueColumn={5}
					/>

					<Col md>

						<SelectWithValidation
							key="validation_status"
							Col={Col}
							type="text"
							label="Status"
							name="validation_status"
							placeholder=""
							value={values.validation_status}
							error={errors.validation_status}
							handleChange={handleChange}
							options={statusValidation}
						/>

					</Col>
				</Row>

				<Row className="mb-3">
					<Col md>
						<ControlAreaWithValidation
							key="desc_validation"
							Col={Col}
							label="Observações"
							name="desc_validation"
							placeholder="Escreva observações pertinentes a validação do arquivo manual"
							value={values.desc_validation}
							error={errors.desc_validation}
							handleChange={handleChange}
						/>
					</Col>
				</Row>

				<Row className="mb-3">
					<Col md>
						<Form.Check
							key="new_version"
							type="switch"
							id="custom-switch"
							name="new_version"
							label="Salvar comentários da última aprovação?"
							checked={values.new_version}
							error={errors.new_version}
							onChange={e => setFieldValue('new_version', e.target.checked)}
						/>
					</Col>
				</Row>

				<div className="mf-approval-div-save">
					<BtnLoader
						loading={loading}
						messageNotLoading="Salvar"
						messageLoading="Salvando"
						style={"btn-loader-135px"}
						variant={"success"}
					/>
				</div>

			</Form>
		)}}
	</Formik>
)

export default ManualFileApproval;